// L'arbre des dossiers est un objet mutable unique, greffé en place au fil des
// réponses de l'API. Le backend renvoie systématiquement deux niveaux
// (Element::listElements avec depth=2), ce qui permet d'afficher un dossier et
// de connaître ses sous-dossiers sans requête supplémentaire.

export function createRoot(){
    return { name : 'Root', type : 'folder', child : [] };
}

export function findFolder(root, path){
    let node = root;
    for(let i = 0; i < path.length; i++){
        if(!node || !node.child){ return null; }
        node = node.child.find(el => el.name === path[i] && el.type === 'folder');
    }
    return node || null;
}

// Greffe `content` sous `path`. Renvoie false si le dossier visé n'existe plus
// dans l'arbre : cas d'une réponse tardive arrivant après un logout, qu'on
// ignore silencieusement plutôt que de planter.
export function setFolderContent(root, path, content){
    const folder = findFolder(root, path);
    if(!folder){ return false; }
    folder.child = content;
    return true;
}

// Profondeur du plus long préfixe de `target` déjà présent dans l'arbre.
// On teste l'existence du noeud, PAS child.length : un dossier vide déjà chargé
// a un child vide parfaitement légitime.
export function deepestLoaded(root, target){
    let node = root;
    let i = 0;
    while(i < target.length){
        const next = node.child && node.child.find(el => el.name === target[i] && el.type === 'folder');
        if(!next){ break; }
        node = next;
        i++;
    }
    return i;
}

// Charge les niveaux manquants entre l'arbre et `target`, à raison d'environ un
// aller-retour tous les deux niveaux.
//
// Renvoie le chemin effectivement atteint. Il est plus court que `target` quand
// un segment n'existe pas sur le disque (deep-link périmé) : l'appelant se
// replie alors sur le dossier valide le plus profond. La condition d'arrêt est
// « la frontière n'a pas avancé », qui couvre aussi le cas d'un serveur qui
// renverrait un contenu incomplet.
export async function ensureLoaded(api, root, target){
    let previous = -1;
    for(;;){
        const reached = deepestLoaded(root, target);
        if(reached <= previous){
            return target.slice(0, reached);
        }
        // Tous les segments existent -> on charge la cible elle-même ; sinon on
        // charge le noeud connu le plus profond, ce qui révèle deux niveaux.
        const fetchPath = (reached >= target.length) ? target : target.slice(0, reached);
        const data = await api.get(fetchPath);
        setFolderContent(root, fetchPath, data.content);
        if(fetchPath.length === target.length){
            return target;
        }
        previous = reached;
    }
}
